/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconBell16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBell16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.667 1.333H7.333l-.24 1.438A3.995 3.995 0 0 0 4.07 5.946l-.498 2.742a2.666 2.666 0 0 1-1.431 1.908l-.141.07V12c0 .527 1.376.985 3.387 1.201a2.667 2.667 0 0 0 5.226 0c2.01-.216 3.387-.674 3.387-1.2v-1.334l-.14-.07a2.666 2.666 0 0 1-1.432-1.909l-.498-2.742a3.995 3.995 0 0 0-3.024-3.175l-.24-1.438Zm.502 11.975a26.822 26.822 0 0 1-2.338 0 1.331 1.331 0 0 0 2.112.302c.09-.09.166-.192.226-.302ZM4.884 8.927l.498-2.742a2.66 2.66 0 0 1 5.236 0l.498 2.742a4 4 0 0 0 1.55 2.495v.02c-.169.062-.402.13-.706.198-.963.215-2.36.36-3.96.36s-2.997-.145-3.96-.36a5.82 5.82 0 0 1-.707-.198v-.02a4 4 0 0 0 1.55-2.495Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconBell24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBell24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13 2h-2l-.36 2.155A5.993 5.993 0 0 0 6.107 8.92l-.748 4.113a4 4 0 0 1-2.147 2.862L3 16v2c0 .79 2.064 1.477 5.081 1.802a4 4 0 0 0 7.838 0C18.936 19.477 21 18.79 21 18v-2l-.211-.106a4 4 0 0 1-2.147-2.862l-.748-4.113a5.993 5.993 0 0 0-4.535-4.764L13 2Zm.753 17.962a40.314 40.314 0 0 1-3.506 0 2 2 0 0 0 3.506 0ZM7.326 13.39l.747-4.113a3.991 3.991 0 0 1 7.854 0l.747 4.113A6 6 0 0 0 19 17.133v.03a8.742 8.742 0 0 1-1.06.297c-1.444.322-3.541.54-5.94.54-2.399 0-4.496-.218-5.94-.54A8.741 8.741 0 0 1 5 17.163v-.03a6 6 0 0 0 2.326-3.743Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconBell = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconBell(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconBell16 {...iconProps} />;
        case '24':
            return <IconBell24 {...iconProps} />;
        default:
            return <IconBell24 {...iconProps} />;
    }
});
